// elementPlus所需要引入的
import En from "./lang/En";
import Hk from "./lang/Hk";
import Cn from "./lang/Cn";
import Id from "./lang/Id";
import Ja from "./lang/Ja";
// @ts-ignore
export default defineI18nConfig(() => ({
	legacy: false,
	fallbackLocale: "En",
	messages: {
		En: En.message,
		Hk: Hk.message,
		Cn: Cn.message,
		Id: Id.message,
		Ja: Ja.message,
	},
}));
